import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { authSuccess } from '../../redux/actions/authActions';
import Notifications from '../../hof/notifications';

class ProtectedRoute extends Route {

  render() {

    if (this.props.auth.authenticated) {
      return <Route path={this.props.path} component={this.props.component} />
    } else {
      const jwt = localStorage.getItem('jwt');
      if (jwt) {
        this.props.onAuthentication(jwt);
        return <Route path={this.props.path} component={this.props.component} />
      } else {
        console.log('Authenticated: ', this.props.auth.authenticated);
        showLoggedOutMessageIfNecessary();
        return <Redirect to="/login" />
      }
    }
  }
}

const mapStateToProps = (state) => {
  return { auth: state.auth }
}

const mapDispatchToProps = dispatch => {
  return {
    onAuthentication: (jwt) => dispatch(authSuccess(jwt))
  }
}

const showLoggedOutMessageIfNecessary = () => {
  const shouldShow = localStorage.getItem('loggedout');
  if (shouldShow) {
    Notifications.showNotification("Logged out", "You've been logged out due to inactivity", 'danger');
    localStorage.removeItem('loggedout');
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute)